import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>Made by Sanjana Gopalswamy 2026</p>
    </footer>
  );
}

export default Footer;
